<template>
    <!-- 公用提示信息页面 -->
    <div class="errorvue" v-if="dialogVisible">
    	<div class="errorTip">
    		<div class='remove_him'>
    			<span>{{text}}</span>
    		</div>
    	</div>
    </div>

  </template>

<script>
export default {
  data() {
    return {
      dialogVisible: true,
      text: ''
    };
  }
};
</script>

<style scoped>
.errorTip {
		position: fixed;
		left: 0;
		top: 0;
		height: 100%;
		width: 100%;
		background-color: rgba(0, 0, 0, 0);
		z-index: 222;
    left: 50%;
    transform: translateX(-50%);
	}

	.remove_him {
		background-color: rgba(0, 0, 0, 0.9);
		padding:1% 5%;
		position: relative;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: white;
		display: block;
		font-size: 30px;
		border-radius: 5px;
		text-align: center;
		z-index: 222;
    display: inline-block;
	}

  /* 横屏样式 */
  @media screen and (min-aspect-ratio: 1/1) {
    .remove_him{
      font-size: 16px;
    }
  }
</style>
